import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";
import "../../../assets/styles/common/listCard.scss";

type GroupMasterData = {
  id: string;
  groupName: string;
  groupNameRuby?: string;
  picName?: string;
  picMail?: string;
  createdAt?: any;
  groupImage?: string;
};

interface GroupListsProps {
  onEdit: (groupId: string) => void;
}

const GroupLists: React.FC<GroupListsProps> = ({ onEdit }) => {
  const [groupMasters, setGroupMasters] = useState<GroupMasterData[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const fetchGroupMasters = async () => {
    setLoading(true);

    const snap = await getDocs(collection(db, "groupMaster"));
    const list: GroupMasterData[] = snap.docs.map((doc) => ({
      id: doc.id,
      ...(doc.data() as Omit<GroupMasterData, "id">),
    }));

    // グループ名順でソート
    list.sort((a, b) =>
      (a.groupName ?? "").localeCompare(b.groupName ?? "", "ja"),
    );

    setGroupMasters(list);
    setLoading(false);
  };

  useEffect(() => {
    fetchGroupMasters();
  }, []);

  if (loading) return <p>loading...</p>;

  return (
    <div className="table-contents">
      <div className="table-main">
        {groupMasters.map((group) => (
          <section className="card-list" key={group.id}>
            <article className="list-card">
              <div className="flex-space-between">
                <div className="flex-align-center">
                  <h2>{group.groupName}</h2>
                </div>
              </div>
              <button onClick={() => navigate(`${group.groupName}`)}>
                グラフ
              </button>
              {group.groupImage && (
                <img
                  src={group.groupImage}
                  alt={group.groupName}
                  className="group-image"
                />
              )}
            </article>
          </section>
        ))}
      </div>
    </div>
  );
};

export default GroupLists;
